__turbopack_context__.v({
  "className": "grenze_gotisch_8394ff27-module__tcSdNW__className",
});
